import { INumberStyleSpecifiable, INumberStyle, NumberFormatKinds } from "../../../../../../../documaker/domain/format/objects";
import { IObjectBeanNumberTextDrawable } from "../../../beans/objects";
import { MapTranslator } from "../../values";

export class NumberStyleTranslator {
  from(bean: IObjectBeanNumberTextDrawable): INumberStyle {
    return {
      formatKind: this.formatKind.from(bean["@text-format"]),
    };
  }

  to(object: INumberStyleSpecifiable) {
    return {
      textFormat: this.formatKind.to(object.numberStyle.formatKind),
    };
  }

  private readonly formatKind = new MapTranslator<NumberFormatKinds, string>([
    { object: NumberFormatKinds.Money,  bean: "1" },
  ], NumberFormatKinds.None, undefined);
}
